export enum Message {
  AudioFrame = "AUDIO_FRAME",
  SpeechStart = "SPEECH_START",
  Misfire = "VAD_MISFIRE",
  SpeechEnd = "SPEECH_END",
  SpeechStop = "SPEECH_STOP",
}
